import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Globe, Rss } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { api, BACKEND } from "@/lib/api";

export function Footer() {
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setC(r.data.company)).catch(() => {});
  }, []);

  return (
    <footer className="relative mt-24 overflow-hidden bg-ink text-cream-100" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-2">
          <Logo light />
          <p className="mt-6 max-w-md font-sans text-sm leading-relaxed text-cream-100/70">
            Strategic planning, consulting and advisory support to help businesses evaluate challenges,
            establish priorities and move forward with a practical plan.
          </p>
        </div>

        <div>
          <p className="font-sans text-xs uppercase tracking-[0.22em] text-gold-400">Explore</p>
          <ul className="mt-5 space-y-3 font-sans text-sm text-cream-100/75">
            <li><Link to="/articles" className="gf-link hover:text-gold-400">Articles</Link></li>
            <li><Link to="/videos" className="gf-link hover:text-gold-400">Videos</Link></li>
            <li><Link to="/services" className="gf-link hover:text-gold-400">Services</Link></li>
            <li><Link to="/financial-planning" className="gf-link hover:text-gold-400">Financial Planning</Link></li>
            <li><Link to="/about" className="gf-link hover:text-gold-400">About</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-sans text-xs uppercase tracking-[0.22em] text-gold-400">Contact</p>
          <ul className="mt-5 space-y-4 font-sans text-sm text-cream-100/75">
            {c && (
              <>
                <li className="flex items-start gap-3">
                  <Phone className="mt-0.5 h-4 w-4 text-gold-400" />
                  <a href={`tel:${c.phone_link}`} className="hover:text-gold-400" data-testid="footer-phone">{c.phone}</a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="mt-0.5 h-4 w-4 text-gold-400" />
                  <span>{c.address}</span>
                </li>
                <li className="flex items-start gap-3">
                  <Globe className="mt-0.5 h-4 w-4 text-gold-400" />
                  <span>{c.website}</span>
                </li>
              </>
            )}
            <li className="flex items-start gap-3">
              <Rss className="mt-0.5 h-4 w-4 text-gold-400" />
              <a href={`${BACKEND}/api/rss.xml`} className="hover:text-gold-400" target="_blank" rel="noreferrer">RSS Feed</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream-100/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 font-sans text-xs text-cream-100/50 sm:flex-row lg:px-10">
          <p>© {new Date().getFullYear()} Goldman Fischer. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-gold-400">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gold-400">Terms</Link>
            <Link to="/admin/login" className="hover:text-gold-400">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
